import JobCard from "@molecules/ObjectCard/ObjectCards/JobCard/JobCard"

import CardsView from "@organisms/ObjectsView/CardsView/CardsView"

export default function JobCardsView() {
    return (
        <CardsView.List<Job>>
            {(job, displayedAttributes) => <JobCard job={job} displayedAttributes={displayedAttributes} />}
        </CardsView.List>
    )
}
